export default __webpack_public_path__ + "static/media/sesame.8ff524a2.svg";